import "../CSS/weiterbildung.css";

import Seo from "../components/Seo";


function WeiterbildungPage() {

    const weiterbildungen = [

        {
            jahr: "2025–2028",
            kurs: "Dipl. Informatiker HF",
            zusatz: "Schwerpunkt Systemtechnik",
            text:
                "Ausbildung zum Dipl. Informatiker HF mit Schwerpunkt Systemtechnik."
        },

        {
            jahr: "2025",
            kurs: "Intensivlehrgang künstliche Intelligenz",
            zusatz: "",
            text:
                "Intensivlehrgang rund um aktuelle Möglichkeiten und Anwendungen der künstlichen Intelligenz."
        },

        {
            jahr: "2024–2025",
            kurs: "Dipl. Informatiker/in HF ICT-Fundamentals",
            zusatz: "",
            text:
                "Grundlagen und zentrale Themen der Informatik als Vorbereitung auf die weiterführende HF-Ausbildung."
        },

        {
            jahr: "2021–2024",
            kurs: "Dipl. Techniker HF Maschinenbau",
            zusatz: "Vertiefungsrichtung Konstruktion – HF Rheintal",
            text:
                "Höhere Fachausbildung im Maschinenbau mit Vertiefung in der Konstruktion."
        },

        {
            jahr: "2022",
            kurs: "Siemens LOGO!",
            zusatz: "Basis und Advance Kurs",
            text:
                "Grundlagen und weiterführende Anwendungen mit Siemens LOGO!."
        },

        {
            jahr: "2019",
            kurs: "SPS TIA Kurs Serv 2",
            zusatz: "",
            text:
                "Weiterführende Schulung im Bereich SPS und Siemens TIA Portal."
        },

        {
            jahr: "2018",
            kurs: "SPS TIA Kurs Serv 1",
            zusatz: "",
            text:
                "Grundlagenschulung im Bereich SPS und Siemens TIA Portal."
        },

        {
            jahr: "2012",
            kurs: "Qualitätsfachmann",
            zusatz: "",
            text:
                "Weiterbildung im Bereich Qualitätsmanagement und Qualitätssicherung."
        },

        {
            jahr: "2005–2007",
            kurs: "Dipl. Techniker HF Betriebstechnik",
            zusatz: "",
            text:
                "Höhere Fachausbildung im Bereich Betriebstechnik."
        },

        {
            jahr: "2004–2005",
            kurs: "Prozessfachmann",
            zusatz: "",
            text:
                "Weiterbildung im Bereich Prozesse, Organisation und betriebliche Abläufe."
        },

        {
            jahr: "1995–1998",
            kurs: "Lehre als Elektromechaniker",
            zusatz: "",
            text:
                "Berufliche Grundausbildung als Elektromechaniker."
        },

        {
            jahr: "1994–1995",
            kurs: "Lehre als Elektroniker",
            zusatz: "abgebrochen",
            text:
                "Begonnene berufliche Grundausbildung als Elektroniker."
        }

    ];


    return (

        <>

            <Seo
                title="Weiterbildung"
                description="Weiterbildungen und Ausbildungen von Ivan Jörg in den Bereichen Informatik, Maschinenbau, Betriebstechnik, Automatisierung und Qualitätsmanagement."
                canonical="https://www.irj.ch/weiterbildung"
            />


            <div className="intro">

                <p>
                    Ich bilde mich gerne laufend weiter und habe in den
                    letzten Jahren diverse Weiterbildungen besucht, die
                    ich hier gerne aufführe.
                    <br />
                    Denn wie heisst es so schön: Wer rastet, der rostet.
                </p>

            </div>


            <main>

                <div className="karten-container">

                    {
                        weiterbildungen.map(
                            (eintrag, index) => (

                                <article
                                    className="content-card"
                                    key={index}
                                >

                                    <span className="card-jahr">
                                        {eintrag.jahr}
                                    </span>


                                    <h2>
                                        {eintrag.kurs}
                                    </h2>


                                    {
                                        eintrag.zusatz && (

                                            <p className="card-zusatz">
                                                {eintrag.zusatz}
                                            </p>

                                        )
                                    }


                                    <p className="card-text">
                                        {eintrag.text}
                                    </p>

                                </article>

                            )
                        )
                    }

                </div>

            </main>

        </>

    );
}


export default WeiterbildungPage;